import React, { useEffect, useState } from "react";
import clienteAxios from "../../axios";

const ArticulosMenu = ({ restauranteId }) => {
    const [articulosMenu, setArticulosMenu] = useState([]);
    const [busqueda, setBusqueda] = useState(""); // Controla la barra de búsqueda

    const [editandoArticulo, setEditandoArticulo] = useState(null); // Controla la edición de artículos
    const [newImage, setNewImage] = useState(null); // Nueva imagen seleccionada
    const [showImageModal, setShowImageModal] = useState(false); // Controla la visibilidad del modal de imagen
    const [modalImageUrl, setModalImageUrl] = useState(null); // Almacena la URL de la imagen para mostrar en el modal

    // Función para obtener los artículos del menú asociados a un restaurante
    const obtenerArticulosMenu = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "articulos_menu"
            });            
        
            setArticulosMenu(response.data.data[0]); // Guardar los artículos del menú
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        obtenerArticulosMenu();  // Llamamos la función para obtener los artículos del menú
    }, []);

    // Función para manejar la búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar artículos del menú por búsqueda
    const articulosFiltrados = articulosMenu.filter(
        (articulo) =>
            articulo.restaurante_id === restauranteId && // Filtrar por restaurante
            articulo.nombre.toLowerCase().includes(busqueda) // Filtrar por búsqueda
    );




    // Función para guardar los cambios del artículo editado
    const guardarArticuloEditado = async () => {
        try {
            let updatedImageUrl = editandoArticulo.fotos;

            // Si hay una nueva imagen, subirla al servidor
            if (newImage) {
                const formData = new FormData();
                formData.append("file", newImage);
                
                const uploadResponse = await clienteAxios.post("/api/documento/", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });

                updatedImageUrl = uploadResponse.data.file.filename; // Obtener el nombre de la imagen subida
            }

            // Actualizar el artículo en el servidor
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "articulos_menu",
                id: editandoArticulo.id,
                restaurante_id: editandoArticulo.restaurante_id,
                nombre: editandoArticulo.nombre,
                descripcion: editandoArticulo.descripcion,
                precio: editandoArticulo.precio,
                categoria: editandoArticulo.categoria,
                fotos: updatedImageUrl // Actualizar la URL de la imagen
            });

            setEditandoArticulo(null);
            setNewImage(null);
            obtenerArticulosMenu(); // Actualizar los artículos después de guardar
        } catch (error) {
            console.log(error);
        }
    };

    // Función para abrir el modal de imagen al hacer clic en la miniatura
    const handleImageClick = (imageUrl) => {           
        setModalImageUrl(imageUrl);
        setShowImageModal(true);
    };




    return (
        <div>
            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-[20px] font-semibold mb-2">Menú:</h3>

                {/* Barra de búsqueda */}
                <input
                    type="text"
                    placeholder="Buscar artículo..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-2 w-full"
                />

      

                <ul>
                    {articulosFiltrados.map((articulo) => (
                        
                        <li key={articulo.id} className="border p-2 mb-2 mt-4 flex items-center">
                            {/* Mostrar la imagen si existe */}
                            {articulo.fotos && articulo.fotos.trim() !== "" ? (
                                <img
                                    src={`/_file/${articulo.fotos.split(",")[0]}`}
                                    alt="Imagen del artículo"
                                    className="w-24 h-24 object-cover rounded-lg mr-4 cursor-pointer"
                                    onClick={() => handleImageClick(`/_file/${articulo.fotos.split(",")[0]}`)} // Abre el modal con la imagen
                                />
                            ) : (
                                <div className="w-24 h-24 bg-gray-200 flex items-center justify-center rounded-lg mr-4">
                                    {/* Ícono de respaldo si no hay imagen */}
                                    <span className="text-gray-500">Sin imagen</span>
                                </div>
                            )}

                            {editandoArticulo && editandoArticulo.id === articulo.id ? (
                                <div className="flex flex-col">
                                    
                                </div>
                            ) : (
                                <div>
                                    <div className="text-[20px]  mb-2">
                                    <span><strong>{articulo.nombre}</strong> </span><br />
                                    </div>
                                    <span><strong></strong> {articulo.descripcion}</span><br />
                                    <span><strong>Precio:</strong> ${articulo.precio}</span><br />
                            
                            
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Modal para ver la imagen ampliada */}
            {showImageModal && modalImageUrl && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-70">
                    <div className="relative bg-white rounded-lg shadow-lg p-6 max-w-4xl w-full">
                        <img src={modalImageUrl} alt="Imagen ampliada" className="w-full h-auto object-contain" />
                        <button
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                            onClick={() => setShowImageModal(false)}
                        >
                            &#10005;
                        </button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default ArticulosMenu;
